import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import moment from 'moment/moment';
import { IPotentialSavingsDTO } from '../dto/i-potential-savings.dto';

@Component({
	selector: 'app-total-savings',
	templateUrl: './total-savings.component.html',
	styleUrls: ['./total-savings.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TotalSavingsComponent implements OnInit {
	@Input() public isExtended: boolean;
	@Input() public isMonthlyState: boolean;
	@Input() public isZestyDomain: boolean;
	@Input() public isEDP: boolean;
	@Input() public data: IPotentialSavingsDTO;

	@Output() public toggleIsMonthlyState: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() public expandPsDialog: EventEmitter<void> = new EventEmitter<void>();
	@Output() public applyButtonClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() public toggleEDP: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() public refreshPsData: EventEmitter<void> = new EventEmitter<void>();
	@Output() public close: EventEmitter<void> = new EventEmitter<void>();
	@Output() public shrinkModal: EventEmitter<void> = new EventEmitter<void>();

	public isRefreshDataAllowed: boolean;

	public get savings(): number {
		return this.isMonthlyState ? this.data.monthlyPS : this.data.annualPS;
	}

	public get dataOriginText(): string {
		return this.data.hasMaster
			? 'The data is based on your payer account, which includes all ' +
					this.data.accounts.totalAccounts +
					' accounts in your AWS organization'
			: `The data is based on ${this.data.accounts.onboardedAccounts} onboarded accounts. Connect your payer account to get a more precise estimate.`;
	}

	public get applyBtn(): string {
		if (!this.data.hasMaster) {
			return 'Add more accounts';
		}

		if (this.isExtended) {
			return 'Show less';
		} else {
			return 'Breakdown';
		}
	}

	public ngOnInit(): void {
		this.isRefreshDataAllowed = !this.isValidDate(this.data.updatedAt);
	}

	public toggleIsMonthly(isMonthlyState: boolean): void {
		this.toggleIsMonthlyState.emit(isMonthlyState);
	}

	public apply(): void {
		if (!this.data.hasMaster) {
			this.applyButtonClicked.emit(this.data.hasMaster);
			return;
		}

		if (this.isExtended) {
			this.shrinkModal.emit();
		} else {
			this.expandPsDialog.emit();
		}
	}

	public refreshData(): void {
		this.refreshPsData.emit();
	}

	/**
	 * Checks if the current date is equal the given date.
	 * @param {string} dateStr - The date string in the format BE serve as -  'YYYY-MM-DD'.
	 * @returns {boolean} Returns true if the current date is equal the given date, false otherwise.
	 */
	private isValidDate(dateStr: string): boolean {
		const currentDate = moment().format('YYYY-MM-DD');

		return dateStr === currentDate;
	}

	public onChange($event: Event): void {
		const checkbox = $event.target as HTMLInputElement;
		this.toggleEDP.emit(checkbox?.checked);
	}
}
